/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Switch_To_Dark_ThemeInputs */

const en_switch_to_dark_theme = /** @type {(inputs: Switch_To_Dark_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to dark theme`)
};

const es_switch_to_dark_theme = /** @type {(inputs: Switch_To_Dark_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar a tema oscuro`)
};

/**
* | output |
* | --- |
* | "Switch to dark theme" |
*
* @param {Switch_To_Dark_ThemeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const switch_to_dark_theme = /** @type {((inputs?: Switch_To_Dark_ThemeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switch_To_Dark_ThemeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_switch_to_dark_theme(inputs)
	return es_switch_to_dark_theme(inputs)
});